import { render, staticRenderFns } from "./AcceptCoinsOrTransaction.vue?vue&type=template&id=0e683f54&scoped=true&"
import script from "./AcceptCoinsOrTransaction.vue?vue&type=script&lang=ts&"
export * from "./AcceptCoinsOrTransaction.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptCoinsOrTransaction.vue?vue&type=style&index=0&id=0e683f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e683f54",
  null
  
)

export default component.exports